import type { FC } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import type { StyleProp, ViewStyle } from 'react-native';
import { SvgIconType } from '@thermenresorts/icons';
import Colors from 'src/core/utils/Colors';
import Dimens from 'src/core/utils/Dimens';
import Fonts from 'src/core/utils/Fonts';
import Styles from 'src/core/utils/Styles';
import Translations from 'src/core/utils/Translations';
import SvgIcon from 'src/presentation/components/atoms/SvgIcon';
import { TertiaryButton, TertiaryOutlineButton } from 'src/presentation/components/molecules/Button';

interface Props {
	heading: string;
	onPressLink: () => void;
	onPressBuy: () => void;
	style?: StyleProp<ViewStyle>;
}

const BathCardLinkOrBuyCard: FC<Props> = ({ heading, onPressLink, onPressBuy, style }) => {
	return (
		<View style={[styles.card, Styles.card.shadowSoft, style]}>
			<View style={styles.header}>
				<SvgIcon name={SvgIconType.cardAlt} size={Dimens.iconSize16} tintColor={Colors.gray900} />
				<Text style={styles.heading}>{heading}</Text>
			</View>

			<Text style={styles.intro}>{Translations.bathcardAcquireIntro}</Text>

			<View style={styles.actions}>
				<TertiaryOutlineButton extraStyle={styles.action} label={Translations.bathcardLinkCard} onPress={onPressLink} />
				<TertiaryButton extraStyle={styles.action} label={Translations.bathcardBuyCard} onPress={onPressBuy} />
			</View>
		</View>
	);
};

const styles = StyleSheet.create({
	card: {
		backgroundColor: Colors.goldPale,
		borderRadius: Dimens.borderRadius4,
		padding: Dimens.padding20,
		gap: Dimens.gap16,
	},
	header: {
		flexDirection: 'row',
		alignItems: 'center',
		gap: Dimens.gap10,
	},
	heading: {
		flex: Dimens.flex1,
		color: Colors.gray900,
		fontFamily: Fonts.ptSerif,
		fontSize: Dimens.fontSize18,
		lineHeight: Dimens.lineHeight24,
	},
	intro: {
		color: Colors.gray800,
		fontFamily: Fonts.barlow,
		fontSize: Dimens.fontSize14,
		lineHeight: Dimens.lineHeight22,
	},
	actions: {
		flexDirection: 'row',
		gap: Dimens.gap12,
	},
	action: {
		flex: Dimens.flex1,
	},
});

export default BathCardLinkOrBuyCard;
